import React from 'react';
import { useTranslation } from 'react-i18next';
import Block from '../../../Block';
import PropTypes from 'prop-types';
import { Loader } from "../../../loader/Loader";
import ShowItem from "../../../ShowItem";
import {formatDate} from "../../../Format";

const GeneralBlock = ({publisher, ...props}) => {
  const { t } = useTranslation();
  const boolToEnabledString = (bool) => ( bool ? t("enabled") : t("disabled") )
  const formatBool = (bool) => ( bool ? t('yes') : t('no') )
  const loaderProps = { success: props.isSuccess, error: props.isError, retry: props.retry }

  return (
    <Block title={t('publisher.general.general')}>
      <Loader {...loaderProps} minHeight={"100%"}>
        <ShowItem label={t('publisher.status')} value={boolToEnabledString(publisher.enabled)}/>
        <ShowItem label={t('publisher.environment')} value={publisher.environment}/>
        <ShowItem label={t('publisher.test_date')} value={formatDate(publisher.test_date)}/>
        <ShowItem label={t('publisher.terminated_at')} value={formatDate(publisher.terminated_at)}/>
        <ShowItem label={t('publisher.beacon_mode')} value={boolToEnabledString(publisher.enabled)}/>
        <ShowItem label={t('publisher.id')} value={publisher.id}/>
        <ShowItem label={t('publisher.created_at')} value={formatDate(publisher.created_at)}/>
        <ShowItem label={t('publisher.production_date')} value={formatDate(publisher.production_date)}/>
        <ShowItem label={t('publisher.cmp_access')} value={formatBool(publisher.can_configure_cmp)}/>
        <ShowItem label={t('publisher.has_devices_view')} value={formatBool(publisher.has_devices_view)}/>
      </Loader>
    </Block>
  )
}

GeneralBlock.propTypes = {
  publisher: PropTypes.object
}

export default GeneralBlock
